import styled, { css } from 'styled-components';
import { gte } from '@lendi-ui/breakpoint';
import { Button } from '@lendi-ui/button';
import getColour, { ValidHex } from '@lendi-ui/commons/colours';
import { ml, mt } from '@lendi-ui/spacing';
import { body, heading } from '@lendi-ui/typography';

interface AccordionHeaderTextProps {
  shouldWrap?: boolean;
}

export const AccordionHeaderText = styled.div<AccordionHeaderTextProps>`
  overflow: hidden;
  ${({ shouldWrap }) =>
    !shouldWrap &&
    css`
      text-overflow: ellipsis;
      white-space: nowrap;
    `}

  ${heading({ size: 'xs' })}
`;

export const AccordionSubHeaderText = styled.div`
  font-weight: normal;
  color: ${() => getColour('text', 'subtle')};
  ${body({ size: 'xs' })};
`;

export const AddButton = styled(Button)`
  display: block;
  margin: 0 auto;
  ${mt('md')}
  ${gte('md')`
    width: calc(2 / 3 * 100%);
  `}
`;

export const PrimaryButton = styled(Button)`
  display: block;
  margin: 0 auto;
  ${mt('sm')}
`;

interface ColouredCircleProps {
  backgroundColour: ValidHex;
}

export const ColouredCircle = styled.span<ColouredCircleProps>`
  width: 12px;
  height: 12px;
  ${ml('md')}
  border-radius: 50%;
  display: inline-block;
  background-color: ${({ backgroundColour }) => backgroundColour};
`;
